<template>
    <div class="c-navigation__title" :class="{ 'is-collapsed': isCollapsed }">
        <div class="c-navigation__home bg-primary text-white flex justify-center items-center w-auto h-full px-4 sm:pl-24 sm:pr-12" rel="home">
            <svg
                ref="logo"
                class="h-6 sm:h-10 transition-all duration-500 ease-in-out fill-current"
                aria-labelledby="app-title"
                viewBox="0 0 551 114"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                stroke-linejoin="round"
                stroke-miterlimit="1.414"
            >
                <title id="app-title">{{ data.logoTitle }}</title>

                <!-- K -->
                <path
                    class="k1"
                    d="M24.7 49.1h-6.3v29.6H.5V3.9h17.9V33h6.5L46.3 3.9h22l-29 36.5 31.4 38.3H48.2L24.7 49.1z"
                />

                <!-- linik – fade out when collapsed -->
                <path
                    class="linik-letter transition-opacity duration-300"
                    :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                    :style="{ transitionDelay: isCollapsed ? '0ms' : '200ms' }"
                    d="M74.6 3.9h17.9v74.9H74.6z"
                />
                <path
                    class="linik-letter transition-opacity duration-300"
                    :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                    :style="{ transitionDelay: isCollapsed ? '50ms' : '150ms' }"
                    d="M119.9 26.3v52.4h-16.7V26.3h16.7zm1.6-16.6c-.1-5.4-4.6-9.8-10-9.7-5.5 0-10 4.4-10 9.9s4.4 10 9.9 10 10-4.4 10-9.9c.1 0 .1-.1.1-.3z"
                />
                <path
                    class="linik-letter transition-opacity duration-300"
                    :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                    :style="{ transitionDelay: isCollapsed ? '100ms' : '100ms' }"
                    d="M160.8 24.9c-7 0-12.3 2.5-15.6 8v-6.6h-16v52.4h16.7V50.5c0-6.8 3.9-9.9 8.5-9.9 5.2 0 8.3 3.5 8.3 9.7v28.5h16.7V44.3c0-12.1-8.1-19.5-18.6-19.4z"
                />
                <path
                    class="linik-letter transition-opacity duration-300"
                    :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                    :style="{ transitionDelay: isCollapsed ? '150ms' : '50ms' }"
                    d="M205.1 26.3v52.4h-16.7V26.3h16.7zm1.6-16.6c-.1-5.4-4.6-9.8-10-9.7-5.5 0-10 4.4-10 9.9s4.4 10 9.9 10 10-4.4 10-9.9c.1 0 .1-.1.1-.3z"
                />
                <path
                    class="linik-letter transition-opacity duration-300"
                    :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                    :style="{ transitionDelay: isCollapsed ? '200ms' : '0ms' }"
                    d="M231 1.7h-16.7v77h16.8V58.5h3.6l12.9 20.3h20.2L248.3 51l19.4-24.8h-20.3L235 43.6h-4V1.7z"
                />

                <!-- Rente group – slides left when collapsed -->
                <g
                    class="rente transition-transform duration-500 ease-in-out"
                    :style="{
            transform: isCollapsed ? 'translateX(-197px)' : 'translateX(0)',
            transitionDelay: isCollapsed ? '200ms' : '0ms',
          }"
                >
                    <!-- R -->
                    <path
                        d="M304.3 3.9c18.5 0 28.3 9.2 28.3 24 0 11.8-7.5 20.2-20.9 22.3l21.5 28.6h-21.3l-19.7-28h-2.6v28h-17.9V3.9h32.6zm-.3 31.9c6.5 0 10.4-2.5 10.4-7.9s-4.1-7.8-10.4-7.8h-14.5v15.7H304z"
                    />

                    <!-- ente – fade out when collapsed -->
                    <path
                        class="ente-letter transition-opacity duration-300"
                        :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                        :style="{ transitionDelay: isCollapsed ? '0ms' : '250ms' }"
                        d="M360.6 24.8c-15.9 0-26.9 11.5-26.9 28 0 16.3 11.2 27.3 27.6 27.3 9.7 0 17.6-3.2 23.1-8.6l-10.8-10.1c-3.1 2.9-7.2 4.5-11.4 4.6-5.8 0-9.8-2.7-11.2-8.4h35.6c.2-1.7.3-3.5.3-5.2-.1-16.3-10.7-27.6-26.3-27.6zm9.5 22.3c-1.4-5.2-4.6-8-9.5-8-5.2 0-8.3 2.8-9.6 8h19.1z"
                    />
                    <path
                        class="ente-letter transition-opacity duration-300"
                        :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                        :style="{ transitionDelay: isCollapsed ? '50ms' : '200ms' }"
                        d="M425.1 24.9c-7 0-12.3 2.5-15.6 8v-6.6h-16v52.4h16.7V50.5c0-6.8 3.9-9.9 8.5-9.9 5.2 0 8.3 3.5 8.3 9.7v28.5h16.7V44.3c0-12.1-8.1-19.5-18.6-19.4z"
                    />
                    <path
                        class="ente-letter transition-opacity duration-300"
                        :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                        :style="{ transitionDelay: isCollapsed ? '100ms' : '150ms' }"
                        d="M492.1 26.3h-17.9V11h-16.7v15.3h-9.8v14.8h9.8v17.4c0 13.2 6.4 21.6 20.4 21.6 6.7.2 13.2-1.9 18.6-5.8l-5.8-13c-2.6 1.5-6 3.3-9.1 3.3-4.2 0-7.4-2.1-7.4-8.1V41.1h17.9V26.3z"
                    />
                    <path
                        class="ente-letter transition-opacity duration-300"
                        :class="isCollapsed ? 'opacity-0' : 'opacity-100'"
                        :style="{ transitionDelay: isCollapsed ? '150ms' : '100ms' }"
                        d="M524.2 24.8c-15.9 0-26.9 11.5-26.9 28 0 16.3 11.2 27.3 27.6 27.3 9.7 0 17.6-3.2 23.1-8.6l-10.7-10.1c-3.1 2.9-7.2 4.5-11.4 4.6-5.8 0-9.8-2.7-11.2-8.4h35.5c.2-1.7.3-3.5.3-5.2-.1-16.3-10.7-27.6-26.3-27.6zm9.5 22.3c-1.4-5.2-4.6-8-9.5-8-5.2 0-8.3 2.8-9.6 8h19.1z"
                    />
                </g>

                <!-- Line – shrinks when collapsed -->
                <path
                    class="line transition-transform duration-500 ease-in-out origin-left"
                    :style="{
            transform: isCollapsed ? 'scaleX(0.25)' : 'scaleX(1)',
            transitionDelay: isCollapsed ? '200ms' : '0ms',
          }"
                    d="M0 95.3h549.7v15.9H0z"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
            isCollapsed: false,
            scrollThreshold: 50,
        };
    },
    methods: {
        onScroll() {
            this.isCollapsed = window.scrollY > this.scrollThreshold;
        },
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },
};
</script>
